<template>
  <div id="loginview" :class="mobie_login?'mob_login':''">
        <div class="column">
          <ul>
            <!-- <li class="loginview01"><a href="#">作者在线注册</a></li>
            <li class="loginview02"><a href="#">作者投稿查稿</a></li>
            <li class="loginview03"><a href="#">专家在线审稿</a></li>
            <li class="loginview04"><a href="#">编辑在线办公</a></li> -->
			<li class="logined logined_in"  v-show="userInfo" style="border-radius: 5px;margin-bottom: 3px;font-size:15px">
			   <div class="usernamem">
				    欢迎您：<a :title="UserName" href="javascript:void(0);" class="username" style="display: inline-block;line-height: 20px;padding: 0;font-size:15px">{{UserName}}</a>
			   </div>
			   <a  style="cursor: pointer;color:#ffab22;display: inline-block;height: 20px;line-height: 20px;padding: 0;font-size:15px" @click="LoginOut">退出</a> 本系统！</li>

			<li class="loginview01" v-if="!userInfo"><a @click="goReg()" ><img src="../assets/images/login_button1.png"><span class="login-text">作者在线注册</span></a></li>
		   <li class="loginview02" v-if="!userInfo"><a @click="goLogin(1)"  ><img src="../assets/images/login_button2.png"><span class="login-text">作者在线投稿</span></a></li>
		   <!-- <li class="loginview03" v-if="!userInfo"><a @click="goLogin(2)"><img src="../assets/images/login_button1.png"><span class="login-text">编辑在线办公</span></a></li> -->
		   <li class="loginview04" v-if="!userInfo"><a @click="goLogin(3)"><img src="../assets/images/login_button3.png"><span class="login-text">专家在线审稿</span></a></li>

		   <li class="logined logined_in01" v-if = "userInfo&&userInfo.RoleID.indexOf('Authors')!=-1"><a @click="goLogin(1)"  href="javascript:void(0);"><div class="login_img pc_mo"><img src="../assets/images/quick2.png"></div><span class="login-text">进入作者投稿查稿</span></a></li>
		   <!-- <li class="logined logined_in02" v-if = "userInfo&&userInfo.RoleID.indexOf('Editors')!=-1"><a @click="goLogin(2)"><div class="login_img pc_mo"><img src="../assets/images/quick3.png"></div><span class="login-text">进入编辑在线办公</span></a></li> -->
		   <li class="logined logined_in03" v-if = "userInfo&&userInfo.RoleID.indexOf('Experts')!=-1"><a @click="goLogin(3)"><div class="login_img pc_mo"><img src="../assets/images/quick4.png"></div><span class="login-text">进入专家在线审稿</span></a></li>
          </ul>
        </div>
		 <div class="clearfix"></div>
      </div>
</template>

<script>
    export default {
        name: "Logincontrol",
      data(){
          return{
            Systemlist:[
              "作者投稿查稿",
			  "编辑在线办公",
			  "专家在线审稿"
            ],
			userInfo:"",
			UserName:"",
			type:["Authors","Editors","Experts"],
			mobie_login:false
          }
      },
	  created() {
	  	this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"))
		if(this.userInfo){
			this.UserName = this.userInfo.UserName
		}
		if(this.$route.path == '/NewsDetails' || this.$route.path == '/FixedBody'){
				this.mobie_login=true
		}
	  },
	  methods:{
		  LoginOut(){
			//退出登录
			window.localStorage.removeItem("userInfo")
			sessionStorage.removeItem('eqcode');
			location.reload() 
		  },
		  goLogin(num){
			 
			  if(window.localStorage.getItem("userInfo")){
				 if(num==1){
				 	var urldomain = "/author/#/";
				 	window.location.href=urldomain;
				    return  						
				  }else if(num==2){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/editor/#/editor/Index";
				 	 window.location.href=urldomain;
				  return  					       
				  }else if(num==3){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/expert/#/examine-manuscripts";
				 	 window.location.href=urldomain;
				 	 return 					 	 
				 	 }	
			  }else{
				  //num 1-作者 2-编辑办公 3-专家审稿
				  window.sessionStorage.setItem("Login",num)
				  this.$router.push({
				    path: '/Login'// 跳转至登录
				  })
			  }
		  },
		  goReg(){
			  this.$router.push({
			    path: '/regist'// 跳转至登录
			  })
		  }
	  }
    }
</script>

<style scoped>
.login-img img{
	margin-right: 8px; position: relative; top: 3px;
}

.logined{
	line-height: 30px;
}

.usernamem{
	width: 80%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 15px;
}
.logined{ line-height: 20px !important; text-align: center;}
.logined .usernamem{ padding: 0 !important; width: 100%;}

@media (max-width:768px) {
  #loginview{
    margin-left: 2%;
	margin-right: 1%;
  }
 
}
@media (max-width:1024px){
	#loginview .column ul li{
		width: 100% ;
	}
	 #loginview .column li .login-text{
	  font-size: 18px !important;
  }
}
@media (max-width:768px){
.mob_login{
	display: none;
}
}

#loginview .column {
    clear: both;
    padding: 0;
}
#loginview .column ul{
	display: flex;
	flex-wrap: wrap;
}
#loginview .column ul li{
	width: 100%;
	height: 50px;
	margin: 3.5px;
	text-align: center;
	border-radius: 25px;
	border-bottom: 1px solid #b3b1b1;
}
#loginview .column li {
    font-size: 16px;
    font-weight: bold;
    font-family: Microsoft YaHei;
}
#loginview .column li a span{
color: #fff;	
}
.login_img{
	text-align: center;
}
#loginview .column li .login-text{
	font-size: 18px;
}
#loginview .column li .login-texte{
	font-size: 13px;
	margin-left: 8px;
	color: #c49936;
}

#loginview .column a {
	height: 50px;
	line-height: 50px;
    display: block;
	color: #fff;
	font-weight: 400;
}
#loginview .column a img{
	vertical-align: middle;
	margin-right: 5px;
}
#loginview .loginview01{
	background:linear-gradient(to bottom,#15bbe5,#0e7691) ;
}
#loginview .loginview02{
	background:linear-gradient(to bottom,#fdd148,#c28902) ;
}
#loginview .loginview04{
	background:linear-gradient(to bottom,#15bbe5,#0e7691) ;
}
.logined_in{
	background:linear-gradient(to bottom,#15bbe5,#0e7691) ;
}
.logined_in01{
	background:linear-gradient(to bottom,#fdd148,#c28902) ;
}
.logined_in03{
	background:linear-gradient(to bottom,#15bbe5,#0e7691) ;
}
/* .logined_in03{
	background:linear-gradient(to bottom,#ffdf6d,#ffcd1a) ;
} */

</style>
